module.exports = __webpack_public_path__ + "img/DP458.aedadd91.png";